module.exports = __webpack_public_path__ + "media/images/pic/groups/small/kindergarten-db24aa4d56a4109141d753c5b52f227e.jpeg";